'use strict';
import $ from 'jquery';
import GoogleMapsLoader from 'google-maps';

export default (API) => (selector, location) => {
	let gmaps;

	// Map element and default settings
	const map = {
		selector: selector,
		element: null,
		$element: null,
		instance: null,
		center: location || { lat: 60.169508, lng: 24.938505 },
		zoomDefault: 16,
		styles: [
			{
				stylers: [{ saturation: -55 }],
			},
		],
		markers: [],
	};

	// Map marker icons
	const iconUrl = 'https://studio.intersport.fi/pub/web/v4/img/';
	const icons = {
		marker: iconUrl + 'store-search-marker.png',
		active: iconUrl + 'store-search-marker-active.png',
	};

	// Handle resizing
	$(window)
		.resize(function () {
			if (map.instance) {
				gmaps.event.trigger(map.instance, 'resize');
			}
		})
		.resize();

	// Load google maps script, then initialize map
	if ($(window).width() >= 768) {
		GoogleMapsLoader.KEY = API.config('google.maps.api_key') || window.gmapsKey;
		GoogleMapsLoader.VERSION = '3.34';

		GoogleMapsLoader.load(function (google) {
			gmaps = google.maps;
			initMap();
		});
	}

	// Create map, then controls and markers
	function initMap() {
		map.element = document.querySelector(map.selector);

		if (map.element) {
			map.$element = $(map.element);

			map.instance = new gmaps.Map(map.element, {
				center: map.center,
				zoom: map.zoomDefault,
				styles: map.styles,
				scrollwheel: false,
				disableDefaultUI: true,
			});

			if (map.instance) {
				initControls();

				if (location) {
					const marker = new gmaps.Marker({
						position: location,
						icon: icons.active,
						map: map.instance,
					});
					marker.addListener('click', () => {});
					map.markers.push(marker);
				}
			}
		}
	}

	// Handle custom map controls
	function initControls() {
		$('.map-expand').on('click', () => {
			map.$element.parent().addClass('fullscreen');
			map.instance.setOptions({ scrollwheel: true });
			gmaps.event.trigger(map.instance, 'resize');
		});

		$('.map-contract').on('click', () => {
			map.$element.parent().removeClass('fullscreen');
			map.instance.setOptions({ scrollwheel: false });
			gmaps.event.trigger(map.instance, 'resize');
		});

		$('.map-zoom-in').on('click', () => {
			map.instance.setZoom(map.instance.getZoom() + 1);
		});

		$('.map-zoom-out').on('click', () => {
			map.instance.setZoom(Math.max(0, map.instance.getZoom() - 1));
		});
	}
};
